// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--2iUAG";
export var icon = "heading-module--icon--Kb+tp";
export var sub_heading = "heading-module--sub_heading---FgTH";